import {RouterProps} from "../../RouterProps";
import {Route, Routes} from "react-router-dom";
import ClickRouter from "./click/ClickRouter";
import List from "./List";
import Detail from "./Detail";

export default function DetailUrlRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:contentDetailUrlId'} element={<Detail {...props} />} />
            <Route path={'/clicks/*'} element={<ClickRouter {...props} />} />
        </Routes>
    </>
}